import { Outlet } from "react-router-dom";

import { SidePageWrapper } from "../../../layout/sidePageWrapper/SidePageWrapper";

const ExpiredImagePanel = () => {

  return (
    <SidePageWrapper
      small={true}
      hideDisclaime={true}
      bannerHeading={" "}
      bannerParas={[
        " ",
        " ",
      ]}
    >
      <Outlet />
    </SidePageWrapper>
  );
};
export default ExpiredImagePanel;
